import './polyfills'; // debe ir primero — instala Buffer/global para libs Node-style

import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './app';
import { configureAxiosInterceptors } from './utils/axios';

// ----------------------------------------------------------------------

configureAxiosInterceptors();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
